import React, { useState } from 'react';
import AIAssistant from './AIAssistant';
import './AIAssistantButton.css';

// Simple icon components
const MessageCircle = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={className}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </svg>
);

interface AIAssistantButtonProps {
  userId: string;
  sessionId: string;
  language?: string;
}

const AIAssistantButton: React.FC<AIAssistantButtonProps> = ({
  userId,
  sessionId,
  language = 'en'
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);


  const handleToggle = () => {
    if (isOpen) {
      setIsOpen(false);
      setIsMinimized(false);
    } else {
      setIsOpen(true);
    }
  };

  const handleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  const handleClose = () => {
    setIsOpen(false);
    setIsMinimized(false);
  };

  return (
    <>
      {!isOpen && (
        <button
          className="ai-assistant-button"
          onClick={handleToggle}
          title="Open AI Assistant"
        >
          <MessageCircle size={24} />
          <span className="ai-assistant-button-text">AI Assistant</span>
        </button>
      )}

      {isOpen && (
        <AIAssistant
          isOpen={isOpen}
          onClose={handleClose}
          onMinimize={handleMinimize}
          userId={userId}
          sessionId={sessionId}
          language={language}
        />
      )}
    </>
  );
};

export default AIAssistantButton;
